const Upload = () => import(/* webpackChunkName: 'example' */ './upload');
const Markdown = () => import(/* webpackChunkName: 'example' */ './markdown');
const Drag = () => import(/* webpackChunkName: 'example' */ './drag');
const ImgCropper = () => import(/* webpackChunkName: 'example' */ './imgCropper');
const CropperAndUpload = () => import(/* webpackChunkName: 'example' */ './cropperAndUpload');

const routes = [
  { path: '/example/upload', component: Upload },
  { path: '/example/markdown', component: Markdown },
  { path: '/example/drag', component: Drag },
  { path: '/example/imgCropper', component: ImgCropper },
  { path: '/example/cropperAndUpload', component: CropperAndUpload }
];

export default routes;
